import { Component, ChangeDetectionStrategy, signal, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HomeHeroSlideComponent } from '../home-hero-slide/home-hero-slide.component';
import { CarouselControlsComponent } from '../../../shared/components/carousel-controls/carousel-controls.component';

@Component({
  selector: 'app-home-hero-carousel',
  standalone: true,
  imports: [CommonModule, HomeHeroSlideComponent, CarouselControlsComponent],
  templateUrl: './home-hero-carousel.component.html',
  styleUrls: ['./home-hero-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeHeroCarouselComponent {
  activeIndex = signal(0);
  autoPlayInterval: any;
  private platformId = inject(PLATFORM_ID);

  slides = [
    {
      id: 1,
      image: 'assets/images/home/hero/hero-1.jpg',
      headline: 'Connecting buyers and sellers with unparalleled service.',
      subtext: 'Discover a world of unparalleled luxury and freedom on the open water.',
      ctaText: 'LEARN MORE',
    },
    {
      id: 2,
      image: 'assets/images/home/hero/hero-2.jpg',
      headline: 'Experience the Pinnacle of Marine Luxury.',
      subtext: 'Your trusted yacht brokerage in the Southern United States.',
      ctaText: 'LEARN MORE',
    },
    {
      id: 3,
      image: 'assets/images/home/hero/hero-3.jpg',
      headline: 'Your Gateway to Extraordinary Nautical Adventures.',
      subtext: 'Where sophisticated design meets exceptional performance.',
      ctaText: 'LEARN MORE',
    },
  ];

  ngOnInit() {
    this.startAutoPlay();
  }

  ngOnDestroy() {
    this.stopAutoPlay();
  }

  startAutoPlay() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.autoPlayInterval = setInterval(() => {
      this.next(true); // true means auto-play
    }, 5000);
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }

  next(isAuto = false) {
    if (!isAuto) {
      this.stopAutoPlay();
      this.startAutoPlay();
    }
    this.activeIndex.update((val) => (val + 1) % this.slides.length);
  }

  prev() {
    this.stopAutoPlay();
    this.startAutoPlay();
    this.activeIndex.update((val) => (val - 1 + this.slides.length) % this.slides.length);
  }
}
